import { Box, Paper, useTheme } from "@mui/material";
import { BORDER_RADIUS } from "../../../utils/constants";

const AnnotationMessageBubble = ({
  role,
  children,
  bubbleColor = null,
  textColor = null,
  actionMenu = null,
}) => {
  const theme = useTheme();
  const isOwnMessage = role === "user";

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: isOwnMessage ? "flex-end" : "flex-start",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          position: "relative",
          maxWidth: "85%",
          px: 2,
          py: 1.5,
          borderRadius: `${BORDER_RADIUS * 4}px`,
          ...(isOwnMessage
            ? {
                background: theme.palette.button.primary.main,
                color: theme.palette.button.primary.contrastText,
              }
            : {
                backgroundColor: bubbleColor || "#f5f5f5",
                color: textColor || "#111827",
              }),
          border: "none",
          "&:hover .annotation-message-menu": {
            opacity: 1,
          },
        }}
      >
        {actionMenu ? (
          <Box
            sx={{
              position: "absolute",
              top: 4,
              right: 4,
              zIndex: 1,
            }}
          >
            {actionMenu}
          </Box>
        ) : null}
        {children}
      </Paper>
    </Box>
  );
};

export default AnnotationMessageBubble;
